
// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import axios from 'axios';
// import '../Secretary/Table.css';
// import { API_BASE_URL } from '../../config';


// export default function ProgressReportD() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [reportType, setReportType] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [selectedYear, setSelectedYear] = useState("");

//   // Generate years from a starting year (e.g., 2010) to the current year
//   const currentYear = new Date().getFullYear();
//   const startYear = 2024; // Adjust this as needed
//   const years = Array.from(
//     { length: currentYear - startYear + 1 },
//     (_, i) => startYear + i
//   ).reverse(); // Reverse to show latest years first


// useEffect(() => {
//   const fetchApplications = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/RequestProgressReport.php`);
//       console.log('Fetched Applications:', response.data);
//       setApplications(response.data);
//       if (selectedYear === "") {
//         setApplications(response.data); // Show all applications
//       } else {
//         setApplications(
//           response.data.filter((app) => {
//             const appYear = new Date(app.startDate).getFullYear();
//             return appYear === parseInt(selectedYear);
//           })
//         );
//       }
//     } catch (error) {
//       console.error('Error fetching applications:', error);
//     }
//   };

//   fetchApplications();
// }, [selectedYear]);

//   const handleClose = () => setShowModal(false);

//   const handleShow = (id, type) => {
//     const selectedApp = applications.find((app) => app.Id === id); // Changed to `app.Id`
//     if (selectedApp) { // Check if selectedApp is found
//       setCurrentApp(selectedApp);
//       setReportType(type);
      
//       // Assuming the userName field exists in the application object
//       const username = selectedApp.name || selectedApp.userEmail; // Fallback to email if name is not available
      
//       setEmailBody(
//         `Dear ${username},<br><br>
//         I hope this email finds you well.<br><br>
       
//         As a reminder, per the terms of your Multidisciplinary Research Grant, we kindly request that you submit a detailed six-month/one-year progress report within the next two weeks.<br><br>
//         Please note that the timely submission of this report is crucial, as it will be reviewed by university auditors to assess the allocation of funds. Failure to adhere to this deadline may lead to complications for both the URC and yourself, potentially resulting in the withdrawal of your grant.<br><br>
//         To streamline the review process, please use the attached template for your report.<br><br>
//         We appreciate your prompt attention to this matter. Please feel free to reach out if you have any questions or require further clarification.<br><br>
//         Thank you for your cooperation.<br><br>
//         With best regards,<br>
//         Director/URC`
//       );
//       setShowModal(true);
//     } else {
//       console.error('Selected application not found');
//     }
//   };

//   const handleSendEmail = async () => {
//     if (!currentApp || !currentApp.Id) {
//       alert("Application ID is missing.");
//       return;
//     }
  
//     try {
//       // Prepare the email data
//       const emailData = {
//         email: currentApp.userEmail, // Assuming currentApp has userEmail
//         subject: `Progress Report for Grant Application ID: ${currentApp.Id}`, // Include the application ID in the subject
//         message: emailBody,
//       };
  
//       // Send the email via POST request to Email.php
//       const response = await axios.post(`${API_BASE_URL}/Email.php`, emailData);
  
//       if (response.data.status === 'success') {
//         console.log('Email sent successfully');
//         alert('Email sent successfully!');
//       } else {
//         console.error('Email sending failed:', response.data.message);
//         alert('Failed to send email');
//       }
  
//       handleClose(); // Close the modal after sending the email
//     } catch (error) {
//       console.error('Error sending email:', error);
//       alert('Error sending email');
//     }
//   };
  
//   const handleViewClick = async (app_ID) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
//         responseType: 'blob', // Expect binary data (PDF file)
//       });
  
//       // Create a Blob object and generate a download link
//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
//       link.click();
  
//       // Cleanup
//       URL.revokeObjectURL(link.href);
//     } catch (error) {
//       console.error('Error downloading the file:', error);
//       alert('An error occurred while downloading the application.');
//     }
//   };
  
//   const handleView = (id, reportType) => {
//     console.log(`Viewing ${reportType} report for application ${id}`);
  
//     // Prepare the URL for downloading the file
//     const downloadUrl = `${API_BASE_URL}/RequestProgressReport.php?app_ID=${id}&reportType=${reportType}`;
  
//     // Trigger the download request
//     axios
//       .get(downloadUrl, { responseType: 'blob' }) // Make sure to specify 'blob' as responseType
//       .then((response) => {
//         // Create a link element to trigger the download
//         const link = document.createElement('a');
//         const blob = new Blob([response.data], { type: 'application/pdf'}); // Create blob with the received data
//         link.href = URL.createObjectURL(blob); // Create an object URL for the blob
//         link.download = `${reportType}_report_${id}.pdf`; // Set the filename for the download (you can modify this based on your reportType)
//         link.click();  // Trigger the download
  
//         // Clean up the object URL
//         URL.revokeObjectURL(link.href);
//       })
//       .catch((error) => {
//         console.error('Error downloading the report:', error);
//         alert('An error occurred while downloading the report.');
//       });
//   };
  
//   const handleYearChange = (year) => {
//     setSelectedYear(year);
//     // You can filter applications by year if needed here
//     console.log("Selected Year:", year);
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Request Progress Report</h1>
//      <div className="year-filter">
//   <label htmlFor="year-select">Year: </label>
//   <select
//     id="year-select"
//     value={selectedYear}
//     onChange={(e) => handleYearChange(e.target.value)}
//     className="year-select"
//   >
//     <option value="">Select Year</option>
//     {years.map((year) => (
//       <option key={year} value={year}>
//         {year}
//       </option>
//     ))}
//   </select>
// </div>
//       <Table striped bordered hover>
//         <thead>
         
//           <tr>
//             <th>Application ID</th>
//             <th>Start Date</th>
//             <th>Project Title</th>
//             <th>Application</th>
//             <th>Progress Report Mid</th>
//             <th>Progress Report End</th>
//             <th>Progress Report Final</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Array.isArray(applications) && applications.length > 0 ? (
//             applications.map((app) => (
//               <tr key={app.applicationId}>
//                 <td>{app.Id}</td>
//                 <td>{app.startDate}</td>
//                 <td>{app.projectTitle}</td>
//                 <td>
//                   <button className="view-button" 
//                     onClick={() => handleViewClick(app.Id)}>
//                     Application
//                   </button>
//                 </td>
//                 <td>
//                   <button className="view-button" onClick={() => handleView(app.Id, 'mid')}>
//                     View
//                   </button>
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'mid')}>
//                     Send Email
//                   </button>
//                 </td>
//                 <td>
//                   <button className="view-button" onClick={() => handleView(app.Id, 'end')}>
//                     View
//                   </button>
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'end')}>
//                     Send Email
//                   </button>
//                 </td>
//                 <td>
//                   <button className="view-button" onClick={() => handleView(app.Id, 'final')}>
//                     View
//                   </button>
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'final')}>
//                     Send Email
//                   </button>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="6" style={{ textAlign: 'center' }}>
//                 No applications found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       <Modal show={showModal} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control type="text" value={currentApp ? currentApp.projectTitle : ''} readOnly />
//             </Form.Group>
//             <Form.Group controlId="formEmail">
//               <Form.Label>Email</Form.Label>
//               <Form.Control type="email" value={currentApp ? currentApp.userEmail : ''} readOnly />
//             </Form.Group>
//             <Form.Group controlId="formEmailBody">
//               <Form.Label>Email Body</Form.Label>
//               <Form.Control as="textarea" rows={3} value={emailBody} onChange={(e) => setEmailBody(e.target.value)} />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSendEmail}>
//             Send
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import axios from 'axios';
// import '../Secretary/Table.css';
// import { API_BASE_URL } from '../../config';

// export default function ProgressReportD() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [reportType, setReportType] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [selectedYear, setSelectedYear] = useState("");

//   // Generate years from a starting year (e.g., 2010) to the current year
//   const currentYear = new Date().getFullYear();
//   const startYear = 2024;
//   const years = Array.from(
//     { length: currentYear - startYear + 1 },
//     (_, i) => startYear + i
//   ).reverse();

//   useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/RequestProgressReport.php`);
//         console.log('Fetched Applications:', response.data);
//         if (selectedYear === "") {
//           setApplications(response.data);
//         } else {
//           setApplications(
//             response.data.filter((app) => {
//               const appYear = new Date(app.startDate).getFullYear();
//               return appYear === parseInt(selectedYear);
//             })
//           );
//         }
//       } catch (error) {
//         console.error('Error fetching applications:', error);
//       }
//     };

//     fetchApplications();
//   }, [selectedYear]);

//   const handleClose = () => setShowModal(false);

//   const handleShow = (id, type) => {
//     const selectedApp = applications.find((app) => app.Id === id);
//     if (selectedApp) {
//       setCurrentApp(selectedApp);
//       setReportType(type);
//       const username = selectedApp.name || selectedApp.userEmail;
//       setEmailBody(
//         `Dear ${username},<br><br>
//         I hope this email finds you well.<br><br>
//         As a reminder, per the terms of your Multidisciplinary Research Grant, we kindly request that you submit a detailed six-month/one-year progress report within the next two weeks.<br><br>
//         Please note that the timely submission of this report is crucial, as it will be reviewed by university auditors to assess the allocation of funds. Failure to adhere to this deadline may lead to complications for both the URC and yourself, potentially resulting in the withdrawal of your grant.<br><br>
//         To streamline the review process, please use the attached template for your report.<br><br>
//         We appreciate your prompt attention to this matter. Please feel free to reach out if you have any questions or require further clarification.<br><br>
//         Thank you for your cooperation.<br><br>
//         With best regards,<br>
//         Director/URC`
//       );
//       setShowModal(true);
//     } else {
//       console.error('Selected application not found');
//     }
//   };

//   const handleSendEmail = async () => {
//     if (!currentApp || !currentApp.Id) {
//       alert("Application ID is missing.");
//       return;
//     }

//     try {
//       const emailData = {
//         email: currentApp.userEmail,
//         subject: `Progress Report for Grant Application ID: ${currentApp.Id}`,
//         message: emailBody,
//       };

//       const response = await axios.post(`${API_BASE_URL}/Email.php`, emailData);

//       if (response.data.status === 'success') {
//         console.log('Email sent successfully');
//         alert('Email sent successfully!');
//       } else {
//         console.error('Email sending failed:', response.data.message);
//         alert('Failed to send email');
//       }

//       handleClose();
//     } catch (error) {
//       console.error('Error sending email:', error);
//       alert('Error sending email');
//     }
//   };

//   const handleViewClick = async (app_ID) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
//         responseType: 'blob',
//       });

//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       // link.download = `Application_${app_ID}.pdf`;
//       link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
//       link.click();
//       URL.revokeObjectURL(link.href);
//     } catch (error) {
//       console.error('Error downloading the file:', error);
//       alert('An error occurred while downloading the application.');
//     }
//   };

//   const handleView = (id, reportType) => {
//     console.log(`Viewing ${reportType} report for application ${id}`);
//     const downloadUrl = `${API_BASE_URL}/RequestProgressReport.php?app_ID=${id}&reportType=${reportType}`;
//     axios
//       .get(downloadUrl, { responseType: 'blob' })
//       .then((response) => {
//         const link = document.createElement('a');
//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         link.href = URL.createObjectURL(blob);
//         link.download = `${reportType}_report_${id}.pdf`;
//         link.click();
//         URL.revokeObjectURL(link.href);
//       })
//       .catch((error) => {
//         console.error('Error downloading the report:', error);
//         alert('An error occurred while downloading the report.');
//       });
//   };

//   const handleYearChange = (year) => {
//     setSelectedYear(year);
//     console.log("Selected Year:", year);
//   };

//   // Handle contentEditable changes
//   const handleEmailBodyChange = (e) => {
//     setEmailBody(e.target.innerHTML);
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Request Progress Report</h1>
//       <div className="year-filter">
//         <label htmlFor="year-select">Year: </label>
//         <select
//           id="year-select"
//           value={selectedYear}
//           onChange={(e) => handleYearChange(e.target.value)}
//           className="year-select"
//         >
//           <option value="">Select Year</option>
//           {years.map((year) => (
//             <option key={year} value={year}>
//               {year}
//             </option>
//           ))}
//         </select>
//       </div>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th>Application ID</th>
//             <th>Start Date</th>
//             <th>Project Title</th>
//             <th>Application</th>
//             <th>Progress Report Mid</th>
//             <th>Progress Report End</th>
//             <th>Progress Report Final</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Array.isArray(applications) && applications.length > 0 ? (
//             applications.map((app) => (
//               <tr key={app.Id}>
//                 <td>{`${app.Id}_${new Date().getFullYear()}`}</td>
//                 <td>{app.startDate}</td>
//                 <td>{app.projectTitle}</td>
//                 <td>
//                   <button className="view-button" onClick={() => handleViewClick(app.Id)}>
//                     Application
//                   </button>
//                 </td>
//                 <td>
//                   <button className="view-button" onClick={() => handleView(app.Id, 'mid')}>
//                     View
//                   </button>
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'mid')}>
//                     Send Email
//                   </button>
//                 </td>
//                 <td>
//                   <button className="view-button" onClick={() => handleView(app.Id, 'end')}>
//                     View
//                   </button>
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'end')}>
//                     Send Email
//                   </button>
//                 </td>
//                 <td>
//                   <button className="view-button" onClick={() => handleView(app.Id, 'final')}>
//                     View
//                   </button>
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'final')}>
//                     Send Email
//                   </button>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="7" style={{ textAlign: 'center' }}>
//                 No applications found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       <Modal show={showModal} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control type="text" value={currentApp ? currentApp.projectTitle : ''} readOnly />
//             </Form.Group>
//             <Form.Group controlId="formEmail">
//               <Form.Label>Email</Form.Label>
//               <Form.Control type="email" value={currentApp ? currentApp.userEmail : ''} readOnly />
//             </Form.Group>
//             <Form.Group controlId="formEmailBody">
//               <Form.Label>Email Body</Form.Label>
//               <div
//                 className="email-body-preview"
//                 contentEditable="true"
//                 onInput={handleEmailBodyChange}
//                 dangerouslySetInnerHTML={{ __html: emailBody }}
//                 style={{
//                   border: '1px solid #ced4da',
//                   padding: '10px',
//                   minHeight: '150px',
//                   backgroundColor: '#fff',
//                   borderRadius: '4px',
//                   outline: 'none',
//                 }}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSendEmail}>
//             Send
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import axios from 'axios';
// import '../Secretary/Table.css';
// import { API_BASE_URL } from '../../config';

// export default function ProgressReport() {
//   const [applications, setApplications] = useState([]);
//   const [fileExistence, setFileExistence] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [reportType, setReportType] = useState('');
//   const [emailBody, setEmailBody] = useState('');

//   useEffect(() => {
//     const fetchApplicationsAndFiles = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/RequestProgressReport.php`);
//         console.log('Fetched Applications:', response.data);
//         setApplications(response.data);

//         const existencePromises = response.data.map(async (app) => {
//           const fileTypes = ['progress_midyear', 'progress_endyear', 'progress_final'];
//           const existenceResults = {};

//           for (const fileType of fileTypes) {
//             try {
//               const fileCheckResponse = await axios.get(`${API_BASE_URL}/CheckFileExistence.php`, {
//                 params: { app_ID: app.Id, fileType },
//               });
//               console.log(`File check for app ${app.Id}, ${fileType}:`, fileCheckResponse.data);
//               existenceResults[fileType] = fileCheckResponse.data.exists || false;
//             } catch (error) {
//               console.error(`Error checking ${fileType} for app ${app.Id}:`, error);
//               existenceResults[fileType] = false;
//             }
//           }

//           return { appId: app.Id, files: existenceResults };
//         });

//         const existenceData = await Promise.all(existencePromises);
//         const fileExistenceMap = existenceData.reduce((acc, { appId, files }) => {
//           acc[appId] = files;
//           return acc;
//         }, {});

//         console.log('File Existence Map:', fileExistenceMap);
//         setFileExistence(fileExistenceMap);
//       } catch (error) {
//         console.error('Error fetching applications:', error);
//         setApplications([]);
//       }
//     };

//     fetchApplicationsAndFiles();
//   }, []);

//   const handleClose = () => setShowModal(false);

//   const handleShow = (id, type) => {
//     const selectedApp = applications.find((app) => app.Id === id);
//     if (selectedApp) {
//       setCurrentApp(selectedApp);
//       setReportType(type);
//       const username = selectedApp.name || selectedApp.userEmail;
//       setEmailBody(
//         `Dear ${username},<br><br>
//         I hope this email finds you well.<br><br>
//         As a reminder, per the terms of your Multidisciplinary Research Grant, we kindly request that you submit a detailed ${type === 'mid' ? 'six-month' : type === 'end' ? 'one-year' : 'final'} progress report within the next two weeks.<br><br>
//         Please note that the timely submission of this report is crucial, as it will be reviewed by university auditors to assess the allocation of funds. Failure to adhere to this deadline may lead to complications for both the URC and yourself, potentially resulting in the withdrawal of your grant.<br><br>
//         To streamline the review process, please use the attached template for your report.<br><br>
//         We appreciate your prompt attention to this matter. Please feel free to reach out if you have any questions or require further clarification.<br><br>
//         Thank you for your cooperation.<br><br>
//         With best regards,<br>
//         Director/URC`
//       );
//       setShowModal(true);
//     } else {
//       console.error('Selected application not found');
//     }
//   };

//   const handleSendEmail = async () => {
//     if (!currentApp || !currentApp.Id) {
//       alert('Application ID is missing.');
//       return;
//     }

//     try {
//       const emailData = {
//         email: currentApp.userEmail,
//         subject: `Progress Report for Grant Application ID: ${currentApp.Id}`,
//         message: emailBody,
//       };

//       const response = await axios.post(`${API_BASE_URL}/Email.php`, emailData);

//       if (response.data.status === 'success') {
//         console.log('Email sent successfully');
//         alert('Email sent successfully!');
//       } else {
//         console.error('Email sending failed:', response.data.message);
//         alert('Failed to send email');
//       }

//       handleClose();
//     } catch (error) {
//       console.error('Error sending email:', error);
//       alert('Error sending email');
//     }
//   };

//   const handleView = (id, reportType) => {
//     console.log(`Viewing ${reportType} report for application ${id}`);
//     const fileTypeMap = {
//       mid: 'progress_midyear',
//       end: 'progress_endyear',
//       final: 'progress_final',
//     };
//     const fileType = fileTypeMap[reportType];

//     if (!fileExistence[id]?.[fileType]) {
//       alert('Report not available.');
//       return;
//     }

//     const downloadUrl = `${API_BASE_URL}/RequestProgressReport.php?app_ID=${id}&reportType=${reportType}`;

//     axios
//       .get(downloadUrl, { responseType: 'blob' })
//       .then((response) => {
//         const link = document.createElement('a');
//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         link.href = URL.createObjectURL(blob);
//         link.download = `${reportType}_report_${id}.pdf`;
//         link.click();
//         URL.revokeObjectURL(link.href);
//       })
//       .catch((error) => {
//         console.error('Error downloading the report:', error);
//         alert('An error occurred while downloading the report.');
//       });
//   };

//   const handleViewClick = async (app_ID) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
//         responseType: 'blob',
//       });

//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = `Application_${app_ID}.pdf`;
//       link.click();
//       URL.revokeObjectURL(link.href);
//     } catch (error) {
//       console.error('Error downloading the file:', error);
//       alert('An error occurred while downloading the application.');
//     }
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Request Progress Report</h1>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th>Application ID</th>
//             <th>Start Date</th>
//             <th>Project Title</th>
//             <th>Application</th>
//             <th>Progress Report Mid</th>
//             <th>Progress Report End</th>
//             <th>Progress Report Final</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Array.isArray(applications) && applications.length > 0 ? (
//             applications.map((app) => (
//               <tr key={app.Id}>
//                 <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
//                 <td>{app.startDate}</td>
//                 <td>{app.projectTitle}</td>
//                 <td>
//                   <button className="view-button" onClick={() => handleViewClick(app.Id)}>
//                     Application
//                   </button>
//                 </td>
//                 <td>
//                   {fileExistence[app.Id]?.progress_midyear ? (
//                     <button className="view-button" onClick={() => handleView(app.Id, 'mid')}>
//                       View
//                     </button>
//                   ) : (
//                     <button style={{ backgroundColor: '#859ed0ff', color: '#080707ff', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'not-allowed', fontSize: '14px', opacity: '0.7', transition: 'background-color 0.3s ease, box-shadow 0.2s ease', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }} disabled>
//   Not Available
// </button>
//                   )}
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'mid')}>
//                     Send Email
//                   </button>
//                 </td>
//                 <td>
//                   {fileExistence[app.Id]?.progress_endyear ? (
//                     <button className="view-button" onClick={() => handleView(app.Id, 'end')}>
//                       View
//                     </button>
//                   ) : (
//                      <button style={{ backgroundColor: '#859ed0ff', color: '#080707ff', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'not-allowed', fontSize: '14px', opacity: '0.7', transition: 'background-color 0.3s ease, box-shadow 0.2s ease', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }} disabled>
//   Not Available
// </button>
//                   )}
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'end')}>
//                     Send Email
//                   </button>
//                 </td>
//                 <td>
//                   {fileExistence[app.Id]?.progress_final ? (
//                     <button className="view-button" onClick={() => handleView(app.Id, 'final')}>
//                       View
//                     </button>
//                   ) : (
//                     <button style={{ backgroundColor: '#859ed0ff', color: '#080707ff', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'not-allowed', fontSize: '14px', opacity: '0.7', transition: 'background-color 0.3s ease, box-shadow 0.2s ease', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }} disabled>
//   Not Available
// </button>
//                   )}
//                   <button className="Email-button" onClick={() => handleShow(app.Id, 'final')}>
//                     Send Email
//                   </button>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="7" style={{ textAlign: 'center' }}>
//                 No applications found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       <Modal show={showModal} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control type="text" value={currentApp ? currentApp.projectTitle : ''} readOnly />
//             </Form.Group>
//             <Form.Group controlId="formEmail">
//               <Form.Label>Email</Form.Label>
//               <Form.Control type="email" value={currentApp ? currentApp.userEmail : ''} readOnly />
//             </Form.Group>
//             <Form.Group controlId="formEmailBody">
//               <Form.Label>Email Body</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={10}
//                 value={emailBody}
//                 onChange={(e) => setEmailBody(e.target.value)}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSendEmail}>
//             Send
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import '../Secretary/Table.css';
import { API_BASE_URL } from '../../config';

export default function ProgressReport() {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [fileExistence, setFileExistence] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [currentApp, setCurrentApp] = useState(null);
  const [reportType, setReportType] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  // Generate years for the dropdown (from 2024 to current year)
  const currentYear = new Date().getFullYear();
  const startYear = 2024;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse();

  useEffect(() => {
    const fetchApplicationsAndFiles = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/RequestProgressReport.php`);
        console.log('Fetched Applications:', response.data);
        if (Array.isArray(response.data)) {
          setApplications(response.data);
          // Filter applications by selected year
          if (selectedYear === '') {
            setFilteredApplications(response.data);
          } else {
            setFilteredApplications(
              response.data.filter((app) => {
                const appYear = new Date(app.startDate).getFullYear();
                return appYear === parseInt(selectedYear);
              })
            );
          }

          // Check file existence for all applications
          const existencePromises = response.data.map(async (app) => {
            const fileTypes = ['progress_midyear', 'progress_endyear', 'progress_final'];
            const existenceResults = {};

            for (const fileType of fileTypes) {
              try {
                const fileCheckResponse = await axios.get(`${API_BASE_URL}/CheckFileExistence.php`, {
                  params: { app_ID: app.Id, fileType },
                });
                console.log(`File check for app ${app.Id}, ${fileType}:`, fileCheckResponse.data);
                existenceResults[fileType] = fileCheckResponse.data.exists || false;
              } catch (error) {
                console.error(`Error checking ${fileType} for app ${app.Id}:`, error);
                existenceResults[fileType] = false;
              }
            }

            return { appId: app.Id, files: existenceResults };
          });

          const existenceData = await Promise.all(existencePromises);
          const fileExistenceMap = existenceData.reduce((acc, { appId, files }) => {
            acc[appId] = files;
            return acc;
          }, {});

          console.log('File Existence Map:', fileExistenceMap);
          setFileExistence(fileExistenceMap);
        } else {
          console.error('Unexpected data format:', response.data);
          setApplications([]);
          setFilteredApplications([]);
        }
      } catch (error) {
        console.error('Error fetching applications:', error);
        setApplications([]);
        setFilteredApplications([]);
      }
    };

    fetchApplicationsAndFiles();
  }, [selectedYear]);

  const handleClose = () => setShowModal(false);

  const handleShow = (id, type) => {
    const selectedApp = applications.find((app) => app.Id === id);
    if (selectedApp) {
      setCurrentApp(selectedApp);
      setReportType(type);
      const username = selectedApp.name || selectedApp.userEmail;
      setEmailBody(
        `Dear ${username},<br><br>
        I hope this email finds you well.<br><br>
        As a reminder, per the terms of your Multidisciplinary Research Grant, we kindly request that you submit a detailed ${type === 'mid' ? 'six-month' : type === 'end' ? 'one-year' : 'final'} progress report within the next two weeks.<br><br>
        Please note that the timely submission of this report is crucial, as it will be reviewed by university auditors to assess the allocation of funds. Failure to adhere to this deadline may lead to complications for both the URC and yourself, potentially resulting in the withdrawal of your grant.<br><br>
        To streamline the review process, please use the attached template for your report.<br><br>
        We appreciate your prompt attention to this matter. Please feel free to reach out if you have any questions or require further clarification.<br><br>
        Thank you for your cooperation.<br><br>
        With best regards,<br>
        Director/URC`
      );
      setShowModal(true);
    } else {
      console.error('Selected application not found');
    }
  };

  const handleSendEmail = async () => {
    if (!currentApp || !currentApp.Id) {
      alert('Application ID is missing.');
      return;
    }

    try {
      const emailData = {
        email: currentApp.userEmail,
        subject: `Progress Report for Grant Application ID: ${currentApp.Id}`,
        message: emailBody,
      };

      const response = await axios.post(`${API_BASE_URL}/Email.php`, emailData);

      if (response.data.status === 'success') {
        console.log('Email sent successfully');
        alert('Email sent successfully!');
      } else {
        console.error('Email sending failed:', response.data.message);
        alert('Failed to send email');
      }

      handleClose();
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Error sending email');
    }
  };

  const handleView = (id, reportType) => {
    console.log(`Viewing ${reportType} report for application ${id}`);
    const fileTypeMap = {
      mid: 'progress_midyear',
      end: 'progress_endyear',
      final: 'progress_final',
    };
    const fileType = fileTypeMap[reportType];

    if (!fileExistence[id]?.[fileType]) {
      alert('Report not available.');
      return;
    }

    const downloadUrl = `${API_BASE_URL}/RequestProgressReport.php?app_ID=${id}&reportType=${reportType}`;

    axios
      .get(downloadUrl, { responseType: 'blob' })
      .then((response) => {
        const link = document.createElement('a');
        const blob = new Blob([response.data], { type: 'application/pdf' });
        link.href = URL.createObjectURL(blob);
        link.download = `${reportType}_report_${id}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error('Error downloading the report:', error);
        alert('An error occurred while downloading the report.');
      });
  };

  const handleViewClick = async (app_ID) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Application_${app_ID}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Request Progress Report</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Application ID</th>
            <th>Start Date</th>
            <th>Project Title</th>
            <th>Application</th>
            <th>Progress Report Mid</th>
            <th>Progress Report End</th>
            <th>Progress Report Final</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) && filteredApplications.length > 0 ? (
            filteredApplications.map((app) => (
              <tr key={app.Id}>
                <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
                <td>{app.startDate}</td>
                <td>{app.projectTitle}</td>
                <td>
                  <button className="view-button" onClick={() => handleViewClick(app.Id)}>
                    Application
                  </button>
                </td>
                <td>
                  {fileExistence[app.Id]?.progress_midyear ? (
                    <button className="view-button" onClick={() => handleView(app.Id, 'mid')}>
                      View
                    </button>
                  ) : (
                    <button
                      style={{
                        backgroundColor: '#859ed0ff',
                        color: '#080707ff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        cursor: 'not-allowed',
                        fontSize: '14px',
                        opacity: '0.7',
                        transition: 'background-color 0.3s ease, box-shadow 0.2s ease',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                      }}
                      disabled
                    >
                      Not Available
                    </button>
                  )}
                  <button className="Email-button" onClick={() => handleShow(app.Id, 'mid')}>
                    Send Email
                  </button>
                </td>
                <td>
                  {fileExistence[app.Id]?.progress_endyear ? (
                    <button className="view-button" onClick={() => handleView(app.Id, 'end')}>
                      View
                    </button>
                  ) : (
                    <button
                      style={{
                        backgroundColor: '#859ed0ff',
                        color: '#080707ff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        cursor: 'not-allowed',
                        fontSize: '14px',
                        opacity: '0.7',
                        transition: 'background-color 0.3s ease, box-shadow 0.2s ease',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                      }}
                      disabled
                    >
                      Not Available
                    </button>
                  )}
                  <button className="Email-button" onClick={() => handleShow(app.Id, 'end')}>
                    Send Email
                  </button>
                </td>
                <td>
                  {fileExistence[app.Id]?.progress_final ? (
                    <button className="view-button" onClick={() => handleView(app.Id, 'final')}>
                      View
                    </button>
                  ) : (
                    <button
                      style={{
                        backgroundColor: '#859ed0ff',
                        color: '#080707ff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        cursor: 'not-allowed',
                        fontSize: '14px',
                        opacity: '0.7',
                        transition: 'background-color 0.3s ease, box-shadow 0.2s ease',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                      }}
                      disabled
                    >
                      Not Available
                    </button>
                  )}
                  <button className="Email-button" onClick={() => handleShow(app.Id, 'final')}>
                    Send Email
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center' }}>
                No applications found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Send Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formProjectTitle">
              <Form.Label>Project Title</Form.Label>
              <Form.Control type="text" value={currentApp ? currentApp.projectTitle : ''} readOnly />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={currentApp ? currentApp.userEmail : ''} readOnly />
            </Form.Group>
            <Form.Group controlId="formEmailBody">
              <Form.Label>Email Body</Form.Label>
              <Form.Control
                as="textarea"
                rows={10}
                value={emailBody}
                onChange={(e) => setEmailBody(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSendEmail}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}